import React, { useEffect } from 'react';

import useIsAboveBreakpoint from '@/helpers/useIsAboveBreakpoint';

import LayoutMediumScreen from '@/layouts/LayoutMediumScreen';
import LayoutMobile from '@/layouts/LayoutMobile';
import DModalWelcome from '@/components/Onboarding/DModalWelcome';
import useLayoutStore from '@/stores/layout/layoutStore';
import EmailBanner from '@/components/EmailBanner';

/**
 * This layout serves as the base of the app.
 * It controls which basic layout is displayed according to the device's screen width.
 * The layouts managed here are those that include the main navigation, `MainNav`.
 */

const LayoutShell = ({ children }) => {
  const isAboveMd = useIsAboveBreakpoint('md');
  const { setWelcomeModal, welcomeModal } = useLayoutStore();
  const title = useLayoutStore((state) => state.layoutTitle);
  const progressBar = useLayoutStore((state) => state.progressBar);

  return (
    <div className="flex flex-col h-screen">
      <EmailBanner />
      <div className="flex-1 min-h-0">
        {isAboveMd ? (
          <LayoutMediumScreen title={title} progressBar={progressBar}>
            {children}
            {/* disable this for now - James request {welcomeModal.show && <DModalWelcome />} */}
          </LayoutMediumScreen>
        ) : (
          <LayoutMobile title={title} progressBar={progressBar}>
            {children}
            {/* Disable welcome modal for now - James request {welcomeModal.show && <DModalWelcome />} */}
          </LayoutMobile>
        )}
      </div>
    </div>
  );
};

export default LayoutShell;
